import React from "react";
import style from "./loading.module.css"

class Loading extends React.Component {
  
    render() {
      return (
        <div className={style.loader}>
          {   <span></span> }
        </div>
      )
    }
  }
  
  export default Loading;